var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 32,
    viewBox: "0 0 3 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C1.65685 0 3 1.34315 3 3V29C3 30.6569 1.65685 32 0 32V0Z",
    fill: "#011627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIndicator);
export default __webpack_public_path__ + "static/media/selected-indicator.7ccff26e89fe68fe03f97264279f5593.svg";
export { ForwardRef as ReactComponent };